import React from 'react';
import HomeScreen from "../../homescreen/homescreen";
import LoadingComponent from "../../../components/Loading";
import ErrorMessage from "../../../components/ErrorMessage";
import Service from "../../../service/service";
import SuccessMessage from "../../../components/SuccessMessage";

class RequestPassword extends HomeScreen {

    requestPasswordInfo = {
        username: ''
    };

    state = {
        requestPasswordInfo: this.requestPasswordInfo,
        loading: false,
        errorMessage: null,
        success: false,
        alreadyLogged: false
    };

    service = new Service();

    getScreenName() {
        return 'Request Password Reset';
    }

    componentDidMount() {
        if (this.service.getToken()) {
            this.state.alreadyLogged = true;
            this.state.loading = false;
            this.setState(this.state);
        }
    }

    handleChange = (event) => {
        this.requestPasswordInfo[event.target.name] = event.target.value;
        this.setState(this.requestPasswordInfo);
    };

    submit = () => {
        const { username } = this.requestPasswordInfo;
        if (!username || username.length < 4) {
            this.state.loading = false;
            this.state.errorMessage = 'Please, provide a valid username';
            this.setState(this.state);
            return;
        }

        this.state.loading = true;
        this.state.errorMessage = '';
        this.setState(this.state);
        this.service.requestPasswordReset(username)
            .then(response => {
                console.debug(response);
                this.state.loading = false;
                this.state.success = true;
                this.setState(this.state);
            })
            .catch(error => {
                console.debug(error);
                this.state.loading = false;
                this.state.errorMessage = 'There was an error submitting the request. Please, try again later.';
                this.setState(this.state);
            });

    };

    logout = () => {
        this.service.logout();
        this.state.alreadyLogged = false;
        this.setState(this.state);
    };

    renderHomeContent() {
        const { errorMessage, loading, success, alreadyLogged } = this.state;
        const buttonClass = loading ? 'myButton myButtonDisabled' : 'myButton myButtonActive';

        if (success) {
            return this.renderSuccess();
        }

        if (alreadyLogged) {
            return this.renderAlreadyLoggingScreen();
        }

        return (
            <div>
                <p className='sectionDescription'>To reset your password, please submit your username.</p>
                <div className='formContainer'>
                    <div>
                        <label>Username:</label>
                        <input type='text'
                               name='username'
                               placeholder='Username'
                               value={this.requestPasswordInfo.username}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <LoadingComponent isLoading={loading} />

                    <ErrorMessage errorMessage={errorMessage} type='warning'/>

                </div>

                <div className='buttonContainer'>
                    <div className={buttonClass} onClick={this.submit}>Submit</div>
                </div>
            </div>
        );
    }

    renderAlreadyLoggingScreen = () => {
        return (
            <div>
                <p className='sectionDescription'>You are already logged in.</p>
                <p className='sectionDescription'>If you want to sign up, you will need to sign out first.</p>
                <p className='sectionDescription'>Otherwise, you can check your details <a href='/user_info'>in this link</a>.</p>

                <div className='buttonContainer'>
                    <div className='myButton myButtonActive' onClick={this.logout}>Sign out</div>
                </div>
            </div>

        );
    };

    renderSuccess = () => {
        return (
            <SuccessMessage message="The request has been created. You will receive soon an email with the next steps."/>

        );
    };

}

export default RequestPassword;


// WEBPACK FOOTER //
// ./src/screens/access/requestpassword/index.js